import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const RunsScoredChart = ({ innings, homeAbbr, awayAbbr }) => {
  const { awayRuns, homeRuns, labels } = useMemo(() => {
    const a = [], h = [], l = [];
    innings?.forEach((inn, i) => {
      l.push(`Inn ${i + 1}`);
      a.push(inn.away?.runs ?? 0);
      h.push(inn.home?.runs ?? 0);
    });
    return { awayRuns: a, homeRuns: h, labels: l };
  }, [innings]);

  const option = {
    backgroundColor: 'transparent',
    grid: { top: 20, right: 20, bottom: 40, left: 40 },
    legend: {
      bottom: 0,
      textStyle: { color: '#a9c9b1', fontSize: 10 },
      itemWidth: 12, itemHeight: 8,
    },
    xAxis: {
      type: 'category',
      data: labels,
      axisLabel: { color: '#a9c9b1', fontSize: 9 },
      axisLine: { lineStyle: { color: '#658d71' } },
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLabel: { color: '#a9c9b1', fontSize: 10 },
      axisLine: { lineStyle: { color: '#658d71' } },
      splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } },
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e3a29',
      borderColor: '#658d71',
      textStyle: { color: '#d8ceb3', fontSize: 11 },
    },
    series: [
      {
        name: awayAbbr,
        type: 'bar',
        data: awayRuns,
        itemStyle: { color: 'rgba(169,201,177,0.7)', borderColor: '#a9c9b1', borderWidth: 1 },
        barGap: '10%',
      },
      {
        name: homeAbbr,
        type: 'bar',
        data: homeRuns,
        itemStyle: { color: 'rgba(196,51,62,0.7)', borderColor: '#c4333e', borderWidth: 1 },
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: '180px' }} />;
};

export default RunsScoredChart;